import { render } from "./tab-items.vue?vue&type=template&id=71156aac"
import script from "./tab-items.vue?vue&type=script&lang=js"
export * from "./tab-items.vue?vue&type=script&lang=js"

import "./tab-items.vue?vue&type=style&index=0&id=71156aac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__